import List from 'containers/Advertisement/List';
import Show from 'containers/Advertisement/Show';
import Create from 'containers/Advertisement/Create';

export default { List, Show, Create };
